export interface IFormCaptchaInput {
  token: string;
  action: string;
}

export interface IFormCaptchaResponse {
  success: boolean;
  score?: number;
  error?: string;
  threshold?: number;
}

export enum FormListTag {
  MASTER = 1,
}

export enum FormTag {
  CUSTOM_BUCKET_INTERNET = 12,
  CUSTOM_BUCKET_BUYER = 122,

  PRODUCT_LISTING = 747,
  GENERIC_INQUIRY = 746,
  GENERIC_EVENT_REGISTRATION = 748,
  STAY_UPDATED = 749,
  SELL_TRADE_MY_RV = 750,
  SERVICE = 609,
  VAN_UP = 751,
}
